import { axiosGroup } from "./axiosGroup";

export const getLaunchpadsAPI = async () => {
  const result = await axiosGroup.axiosServerAPI.get("/get_list_pre_order");

  return result.data;
};

export const getNFTsAPI = async () => {
  const result = await axiosGroup.axiosServerAPI.get("/get_list_nft");

  return result.data;
};

export const getNFTAPI = async (id: string) => {
  const result = await axiosGroup.axiosServerAPI.get(`/get_nft/${id}`);

  return result.data;
};

export const approveLaunchpadsAPI = async (preOrderId: string) => {
  const result = await axiosGroup.axiosServerAPI.post("/approve_pre_order", {
    preOrderId,
  });

  return result.data;
};

export const approveNFTsAPI = async (nftStorageId: string) => {
  const result = await axiosGroup.axiosServerAPI.post("/approve_nft", {
    nftStorageId,
    messenger:
      "Your NFT approved by admin. Now you can mint that on the website",
    subject: "Approved nft",
  });

  return result.data;
};

export const cancelLaunchpadsAPI = async (preOrderId: string) => {
  const result = await axiosGroup.axiosServerAPI.post("/cancelled_pre_order", {
    preOrderId,
    messenger:
      "Your NFT rejected by admin. Now you can't mint that on the website",
    subject: "Reject nft",
  });

  return result.data;
};

export const cancelNFTsAPI = async (nftStorageId: string) => {
  const result = await axiosGroup.axiosServerAPI.post("/cancelled_nft", {
    nftStorageId,
  });

  return result.data;
};
